export function getPaymentMethod(ids) {
    let out = [];

    ids.forEach(e => {
        // eslint-disable-next-line default-case
        switch (e) {
            case "PAYPAL":
                out.push({
                    name: "PayPal",
                    icon: ["fab", "paypal"]
                });
                break;
            case "BAR":
                out.push({
                    name: "Bar",
                    icon: ["fas", "money-bill"]
                });
                break;
        }
    })

    return out;
}